module.exports = __webpack_public_path__ + "img/s3.f0acf3d1.png";